document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('[data-amd-customer-portal]');
  if (!root) return;

  // Logged-out visitors clicking a "customers only" tile don't navigate —
  // instead we reveal the notice bar, same behavior as the legacy WP cart's
  // .click-information-popup handler, just without the jQuery dependency.
  var notice = root.querySelector('[data-amd-portal-notice]');
  if (!notice) return;

  root.querySelectorAll('[data-amd-portal-locked-link]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      event.preventDefault();
      notice.hidden = false;
      notice.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });
});
